'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadr';
var iconName = 'fill-drip';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f576';
var svgPathData = ['M102.6 336l290.7 0-115.7 115.7c-7.9 7.9-18.5 12.3-29.7 12.3s-21.8-4.4-29.7-12.3L102.6 336z', 'M194.3 96.4l70.1-70.1C281.3 9.5 304.1 0 328 0s46.7 9.5 63.6 26.3L517.7 152.4C534.5 169.3 544 192.1 544 216s-9.5 46.7-26.3 63.6L311.6 485.7C294.7 502.5 271.9 512 248 512s-46.7-9.5-63.6-26.3L58.3 359.6C41.5 342.7 32 319.9 32 296s9.5-46.7 26.3-63.6L160.4 130.3 103 73c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l57.4 57.4zm0 67.9L92.3 266.3c-6 6-9.9 13.5-11.5 21.7l360.6 0 42.3-42.3c7.9-7.9 12.3-18.5 12.3-29.7s-4.4-21.8-12.3-29.7L357.7 60.3C349.8 52.4 339.1 48 328 48s-21.8 4.4-29.7 12.3L228.3 130.3 281 183c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-52.7-52.7zM102.6 336L218.3 451.7c7.9 7.9 18.5 12.3 29.7 12.3s21.8-4.4 29.7-12.3L393.4 336 102.6 336zM512 544c-35.3 0-64-28.7-64-64 0-25.2 32.6-79.6 51.2-108.7 6-9.4 19.5-9.4 25.5 0 18.7 29.1 51.2 83.5 51.2 108.7 0 35.3-28.7 64-64 64z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFillDrip = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;